var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Chip } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import { appUrls } from "../../../urls";
export var NavLinks = [
    {
        title: 'About Us',
        to: appUrls.ABOUT,
    },
    {
        title: 'Try AI-Powered Document Analysis',
        free: true,
        to: appUrls.FREE_ANALYSIS,
    },
    {
        title: 'Pricing',
        to: appUrls.PRICING,
    }
];
var Navigations = function () {
    var StyledButton = styled(Button)(function (_a) {
        var theme = _a.theme;
        return ({
            fontSize: '15px',
            a: {
                color: theme.palette.text.secondary,
            },
            fontWeight: 500,
            '&.active': {
                backgroundColor: 'rgba(93, 135, 255, 0.15)',
                a: {
                    color: theme.palette.primary.main,
                },
            },
        });
    });
    var location = useLocation();
    var pathname = location.pathname;
    return (_jsx(_Fragment, { children: NavLinks.map(function (navlink, i) { return (_jsx(StyledButton, __assign({ color: "inherit", className: pathname === navlink.to ? 'active' : 'not-active', variant: "text" }, { children: _jsxs(NavLink, __assign({ to: navlink.to }, { children: [navlink.title, ' ', navlink.free ? (_jsx(Chip, { label: "Free!", size: "small", sx: {
                            ml: '6px',
                            borderRadius: '8px',
                            color: 'primary.main',
                            backgroundColor: 'rgba(93, 135, 255, 0.15)',
                        } })) : null] })) }), i)); }) }));
};
export default Navigations;
